<div class="dialog">
  <app-svg src="/assets/icons/64/text.svg" size="2" color="primary"></app-svg>

  <h1>Approval limit reached</h1>
  <p>Quickly find assets in asset asset editing software by copy/pasting filenames of your current Picflow list.</p>

  <button *ngIf="softLimit" (click)="confirm()">Confirm</button>
</div>
